import { buildAssetUrl, normalizeStoredUploadPath } from '../../../../../utils/imageUrl'

/** Resolve /uploads/... or legacy full URL for display (uses VITE_UPLOAD_URL base) */
export const resolveBackendUploadUrl = (pathOrUrl) => {
  if (!pathOrUrl) return ''
  const value = String(pathOrUrl).trim()

  if (/^https?:\/\//i.test(value)) {
    try {
      const { pathname } = new URL(value)
      if (pathname.startsWith('/uploads/')) {
        return buildAssetUrl(pathname) || value
      }
      return value
    } catch {
      return value
    }
  }

  return buildAssetUrl(value) || ''
}

export { normalizeStoredUploadPath } from '../../../../../utils/imageUrl'
